import createSagaMiddleware from 'redux-saga';
import { routerMiddleware } from 'connected-react-router';
import { createBrowserHistory } from 'history';
import { applyMiddleware, createStore, compose } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import thunkMiddleware from 'redux-thunk';

import createRootReducer from './rootReducer';
import mySaga from './rootSaga';

export const history = createBrowserHistory();

export function configureStore(preloadedState = {}) {
  const sagaMiddleware = createSagaMiddleware();

  const middlewares = [
    thunkMiddleware, // remove once in production
    sagaMiddleware,
    routerMiddleware(history)
  ];

  const middlewareEnhancer = composeWithDevTools(
    applyMiddleware(...middlewares)
  );

  const enhancers = [middlewareEnhancer];
  const composedEnhancers = compose(...enhancers);

  const store = createStore(
    createRootReducer(history),
    preloadedState,
    // @ts-ignore
    composedEnhancers
  );

  sagaMiddleware.run(mySaga);

  return store;
}

export const store = configureStore();
